<template>
  <v-row
    class="mb-8 flex-nowrap w-100"
    :class="
      messageByLoginUser
        ? 'flex-row-reverse message-box--owner'
        : 'message-box--participant'
    "
    no-gutters
  >
    <x-avatar :text="getUserNameInitials(senderName, true)" size="24" textSize="10" />
    <div
      class="message-box px-3 pt-2 pb-3 rounded-lg mx-2 font12 positionRelative"
      :class="isDiscovery ? 'w-100' : 'w-50'"
    >
      <message-common-content :messageDetails="messageDetails" :messageGroupType="messageGroupType"/>

      <!-- Message versions -->
      <message-reply-box
        v-if="hasVersions"
        :messageId="messageId"
        :allMessageReply="messageVersions"
        :chatAccessibleBy="chatAccessibleBy"
        @getChildMessages="getChildMessages"
      />
      <!-- Replies on Message -->
      <message-reply-box
        v-if="hasReplies"
        :messageId="messageId"
        :allMessageReply="messageReplies"
        :totalMessageReplies="totalMessageReplies"
        :chatAccessibleBy="chatAccessibleBy"
        :messageGroupType="messageGroupType"
        showMessageReply
        @getChildMessages="getChildMessages"
      />
      <!-- Message Reactions-->
      <v-row class="reactions-wrapper position-absolute" no-gutters>
        <div
          v-for="(reactionDetails, index) in messageDetails.reactions || []"
          :key="index"
        >
          <message-reaction-pill
            :reactionDetails="reactionDetails"
            :chatAccessibleBy="chatAccessibleBy"
            shadowVariant
          />
        </div>
      </v-row>
    </div>
  </v-row>
</template>
<script>
const MessageReactionPill = () =>
  import('@/components/ArchiveSearch/ChatBox/MessageReactionPill');
const MessageReplyBox = () =>
  import('@/components/ArchiveSearch/ChatBox/MessageReplyBox');
const MessageCommonContent = () =>
  import('@/components/ArchiveSearch/ChatBox/MessageCommonContent');
import { mapState } from 'vuex';
export default {
  name: 'message',
  components: { MessageReactionPill, MessageReplyBox, MessageCommonContent },
  props: {
    messageDetails: {
      type: Object,
      required: true
    },
    messageGroupType: String,
    chatAccessibleBy: Array
  },
  computed: {
    ...mapState(['userInformation']),
    senderName() {
      return this.messageDetails?.senderName || '';
    },
    messageByLoginUser() {
      return (
        this.userInformation?.userId === this.messageDetails?.sender?.userId
      );
    },
    messageReplies() {
      return this.messageDetails?.replies?.messages || [];
    },
    totalMessageReplies() {
      return this.messageDetails?.replies?.totalMessageCount || 0;
    },
    hasReplies() {
      return this.messageDetails?.hasReplies;
    },
    hasVersions() {
      return this.messageDetails?.hasVersions;
    },
    messageId() {
      return this.messageDetails?.id || '';
    },
    messageVersions() {
      return this.messageDetails?.versions?.messages || [];
    },
    isDiscovery() {
      return Boolean(this.$route.params?.projectId);
    }
  },

  methods: {
    getChildMessages(childMessagePayload) {
      this.$emit('getChildMessages', childMessagePayload);
    }
  }
};
</script>
<style scoped>
.message-box {
  background-color: #eee;
}
.message-box--owner {
  padding-left: 16%;
}
.message-box--participant {
  padding-right: 16%;
}
.reactions-wrapper {
  bottom: -18px;
  right: 0;
}
</style>
